const fakeNewsService = {
    getNews: async function () {
        return Promise.resolve([
            {
                title: "Stonn op un Danz 2026",
                image: "files/Flyer SOUD.png",
                content: "Wann: Freitag 06.11.2026 ab 18:30\n\r" +
                    "Wo: Scala Club Leverkusen",
                files: [{
                    title: "Stonn op un Danz 2026",
                    src: "files/Flyer SOUD.pdf"
                }]
            },
            {
                title: "Herrensitzung 2026",
                image: "files/Flyer Herrensitzung.png",
                content: "Wann: Sonntag 08.02.2026 ab 13:30\n\r" +
                    "Wo: Festzelt am Marktplatz Opladen\n\r",
                files: [{
                    title: "Herrensitzung 2026",
                    src: "files/Flyer Herrensitzung.pdf"
                }]
            },
            {
                title: "Jünemanns' Ovend 2026",
                image: "files/Flyer Jünnemanns Ovend.png",
                content: "Wann: Samstag 31.01.2026 ab 17:30\n\r" +
                    "Wo: Stadthalle Bergisch Neukirchen\n\r",
                files: [{
                    title: "Jünemanns' Ovend 2026",
                    src: "files/Flyer Jünnemanns Ovend.pdf"
                }]
            },
            {
                title: "Kindersitzung 2026",
                image: "files/Flyer Kindersitzung.png",
                content: "Wann: Sonntag 18.01.2026 ab 13:00\n\r" +
                    "Wo: Scala Club Opladen\n\r",
                files: [{
                    title: "Kindersitzung 2026",
                    src: "files/Flyer Kindersitzung.pdf"
                }]
            },
            {
                title: "Kellerveranstaltungen 2026",
                image: "files/Flyer Kellerveranstaltungen.png",
                // content: "Wann: Sonntag 08.02.2026 ab 13:30\n\r" +
                //     "Wo: Festzelt am Marktplatz Opladen\n\r",
                files: [{
                    title: "Kellerveranstaltungen 2026",
                    src: "files/Flyer Kellerveranstaltungen.pdf"
                }]
            }
        ]);
    }
}

export default fakeNewsService;